export default "__VITE_ASSET__CSPLg9fX__"